
const skillCardData = [
  { title: "HTML", endpointTopic: "html" },
  { title: "CSS", endpointTopic: "css" },
  { title: "JavaScript", endpointTopic: "JavaScript" },
  { title: "React", endpointTopic: "react" },
  { title: "Redux", endpointTopic: "redux" },
  { title: "Angular", endpointTopic: "angular" },
  { title: "NodeJS", endpointTopic: "nodejs" },
  { title: "DBMS", endpointTopic: "dbms" },
  { title: "RDBMS", endpointTopic: "rdbms" },
  { title: "OOPs", endpointTopic: "oops" },
  { title: "SQL", endpointTopic: "sql" },
  { title: "Computer Networks", endpointTopic: "computerNetworks" },
  { title: "Operating System", endpointTopic: "operatingSystem" },
  { title: "Java", endpointTopic: "java" },
  { title: "Python", endpointTopic: "python" },
  { title: "C++", endpointTopic: "c++" },
  { title: "C Programming", endpointTopic: "cProgramming" },
  { title: "Data Structure", endpointTopic: "dataStructure" },
];

export default skillCardData;
